import "core-js/modules/es6.regexp.replace";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import isEmpty from 'lodash/isEmpty';
import { formatImageCloudinary } from '~/helpers/image-helper';
import DescriptionLine from '~/components/organisms/Product/DescriptionLine.vue';
import RichContentMediaText from '~/components/organisms/Product/RichContentMediaText.vue';

var ProductPreview = function ProductPreview() {
  return import('~/components/library/Product/ProductPreview.vue');
};

export default {
  components: {
    DescriptionLine: DescriptionLine,
    RichContentMediaText: RichContentMediaText,
    ProductPreview: ProductPreview
  },
  props: {
    crossRange: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    collectionDescription: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    translationsDescription: {
      type: String,
      default: ''
    },
    translationsLineDescription: {
      type: String,
      default: ''
    },
    translationsLineName: {
      type: String,
      default: ''
    },
    additionalContent: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      mobile: true
    };
  },
  computed: {
    hasAdditionalContent: function hasAdditionalContent() {
      return !isEmpty(this.additionalContent);
    },
    hasLineName: function hasLineName() {
      return !!this.translationsLineName;
    },
    currentImages: function currentImages() {
      var _this = this;

      return Object.values(this.crossRange).slice(0, 6).map(function (img) {
        return _objectSpread({}, img, {
          srcset: _this.formatImageUrl(img.product_image, 200)
        });
      });
    },
    description: function description() {
      if (!this.translationsDescription && !this.collectionDescription) {
        return null;
      }

      return this.translationsDescription;
    }
  },
  mounted: function mounted() {
    this.mobile = this.isMobile();
  },
  methods: {
    formatImageUrl: function formatImageUrl(path, height) {
      var url = path;
      return formatImageCloudinary(url.replace('%height%', height), ['e_trim', "w_".concat(height)]);
    }
  }
};